import { Link } from 'react-router-dom';
import styled from 'styled-components';



export const FlexContainer  = styled.div
.attrs(() => ({
  className: 'col s12  ',
}))`
display:flex !important;
flex-wrap: wrap;
color: #A0A0A0 !important;
font-size: 18px;
font-family: Plus Jakarta Sans;
font-style: normal;
font-weight: 500;
margin-top:20px;
padding:0px !important;
`;




export const AuthBgContainer  = styled.div
.attrs(() => ({
  className: 'col s12  grey',
}))`
background-size:cover;
background-image: url("https://res.cloudinary.com/yalla-ng/image/upload/v1688028004/auth_image_zewqki.png") !important;
background-repeat: no-repeat;
background-size: 100% 100%;
height:1092px;
`;


export const PageTitleText  = styled.h5
.attrs(() => ({
  className: '',
}))`
color: var(--black-1, #18181B);
font-size: 28px;
font-family: Plus Jakarta Sans;
font-style: normal;
font-weight: 600;
`;


export const FormContainer  = styled.div
.attrs(() => ({
  className: '',
}))`
    margin:0px auto !important;
    margin-top:150px !important;
    width:68% !important;
    
    @media only screen and (max-width: 768px) {
        margin-top:150px !important;
        width:88% !important;
    
    }
`;


export const PageLinkText  = styled(Link)`
color: var(--black, #3F3F46);
font-size: 14px;
font-family: Plus Jakarta Sans;
font-style: normal;
font-weight: 500;
line-height: normal;
&:hover,
&:focus{
   color: blue;
}
&:active{
   color: ;
}
`;

export const PageLinkTextNoLink  = styled.p`
color: var(--black, #3F3F46);
font-size: 14px;
font-family: Plus Jakarta Sans;
font-style: normal;
font-weight: 500;
line-height: normal;
cursor: pointer !important;
&:hover,
&:focus{
   color: blue;
}
&:active{
   color: ;
}
`;